import dayjs from "dayjs";

const DEFAULT_DATE_KEYS = [
  "updatedAt",
  "updated_at",
  "createdAt",
  "created_at",
  "notifiedAt",
  "draftedAt",
  "drafted_at",
  "createdDate",
  "created_date",
  "publishedAt",
  "published_at",
];

const normalizeDuration = (duration) =>
  String(duration || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");

export const normalizeListDurationForQuery = (duration) => {
  const normalized = String(duration || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

  const map = {
    day: "DAY",
    today: "DAY",
    daily: "DAY",
    week: "WEEK",
    weekly: "WEEK",
    this_week: "WEEK",
    month: "MONTH",
    monthly: "MONTH",
    this_month: "MONTH",
    year: "YEAR",
    yearly: "YEAR",
    this_year: "YEAR",
    custom: undefined,
    custom_date: undefined,
  };

  return map[normalized] ?? normalized.toUpperCase();
};

export const getListActivityDate = (record, extraKeys = []) => {
  const keys = [...extraKeys, ...DEFAULT_DATE_KEYS];

  for (const key of keys) {
    const value = record?.[key];
    if (!value) continue;

    const parsed = dayjs(value);
    if (parsed.isValid()) {
      return parsed;
    }
  }

  return null;
};

export const matchesListTimePeriod = (record, duration, extraKeys = []) => {
  if (!duration) return true;

  const activityDate = getListActivityDate(record, extraKeys);
  if (!activityDate) return false;

  const normalized = normalizeDuration(duration);
  let start = null;
  let end = null;

  switch (normalized) {
    case "DAY":
    case "TODAY":
      start = dayjs().startOf("day");
      end = dayjs().endOf("day");
      break;
    case "WEEK":
    case "THIS_WEEK":
      start = dayjs().startOf("week");
      end = dayjs().endOf("week");
      break;
    case "MONTH":
    case "THIS_MONTH":
      start = dayjs().startOf("month");
      end = dayjs().endOf("month");
      break;
    case "YEAR":
    case "THIS_YEAR":
      start = dayjs().startOf("year");
      end = dayjs().endOf("year");
      break;
    default:
      return true;
  }

  return (
    (activityDate.isAfter(start) || activityDate.isSame(start)) &&
    (activityDate.isBefore(end) || activityDate.isSame(end))
  );
};

export const matchesListDateRange = (record, startDate, endDate, extraKeys = []) => {
  if (!startDate && !endDate) return true;

  const activityDate = getListActivityDate(record, extraKeys);
  if (!activityDate) return false;

  const start = startDate ? dayjs(startDate).startOf("day") : null;
  const end = endDate ? dayjs(endDate).endOf("day") : null;

  let matches = true;
  if (start) matches = matches && (activityDate.isAfter(start) || activityDate.isSame(start));
  if (end) matches = matches && (activityDate.isBefore(end) || activityDate.isSame(end));

  return matches;
};
